import type { TWagerLimitType } from '~/interfaces/stores/rg.store.interface';

interface IRestriction {
  name: string;
  restrictionTypeId: string;
  mappingCode: string;
}

type TRestrictionMapping = IRestriction[];

export const limitTypes: TWagerLimitType[] = ['daily', 'weekly', 'monthly'];
export const restrictions: TRestrictionMapping = [
  {
    name: 'Incomplete Partial Registration.',
    restrictionTypeId: 'C2917971-C58A-4B85-B767-0931C03F83BC',
    mappingCode: 'C2917971-C58A-4B85-B767-0931C03F83BC',
  },
  {
    name: 'Bonus Abuse.',
    restrictionTypeId: '0E7CA4CD-BC4C-4B5C-AC83-0D96DA18DE84',
    mappingCode: '0E7CA4CD-BC4C-4B5C-AC83-0D96DA18DE84',
  },
  {
    name: 'Gambling Addiction.',
    restrictionTypeId: 'E304303D-4E3B-40AA-9945-14E78AD1159F',
    mappingCode: 'E304303D-4E3B-40AA-9945-14E78AD1159F',
  },
  {
    name: 'Opt In/Out Withdrawal Reversal Cooldown.',
    restrictionTypeId: '45165A40-F269-4B0A-9093-16C42D5596A6',
    mappingCode: '45165A40-F269-4B0A-9093-16C42D5596A6',
  },
  {
    name: 'Login Attempts Exceeded Cooldown.',
    restrictionTypeId: 'CEEAE20E-044C-4162-B1D7-17D9F9771F6B',
    mappingCode: 'CEEAE20E-044C-4162-B1D7-17D9F9771F6B',
  },
  {
    name: 'Responsible Gaming (Cooling Off).',
    restrictionTypeId: '7E93F963-C4BA-4898-AA46-2F68EB9BF157',
    mappingCode: '7E93F963-C4BA-4898-AA46-2F68EB9BF157',
  },
  {
    name: 'I Have A Gambling Problem (Self Exclusion) Customer.',
    restrictionTypeId: '90E133AC-305E-43CF-BC99-3182EDEE43AF',
    mappingCode: '90E133AC-305E-43CF-BC99-3182EDEE43AF',
  },
  {
    name: 'Compliance Account Termination.',
    restrictionTypeId: '4B3FE35F-AF89-4640-AEA9-3F3368B900A9',
    mappingCode: '4B3FE35F-AF89-4640-AEA9-3F3368B900A9',
  },
  {
    name: 'Player Request.',
    restrictionTypeId: '50AC58F6-9C0F-4207-BE00-4560F06829BD',
    mappingCode: '50AC58F6-9C0F-4207-BE00-4560F06829BD',
  },
  {
    name: 'Responsible Gaming (Session Limit).',
    restrictionTypeId: '2EE899C8-2773-4859-A35E-48B12BDA4018',
    mappingCode: '2EE899C8-2773-4859-A35E-48B12BDA4018',
  },
  {
    name: 'Permanent Self Exclusion.',
    restrictionTypeId: 'F61CFF4C-11C0-43A2-8CBF-49F5C56AA4F4',
    mappingCode: 'F61CFF4C-11C0-43A2-8CBF-49F5C56AA4F4',
  },
  {
    name: 'Cool Off.',
    restrictionTypeId: '3ADF613F-AEE0-48C1-91AB-4A1F3FA3DD3D',
    mappingCode: '3ADF613F-AEE0-48C1-91AB-4A1F3FA3DD3D',
  },
  {
    name: 'Bank Notification.',
    restrictionTypeId: '0C41D2AF-59E4-4D8E-B574-4C25BD71EB56',
    mappingCode: '0C41D2AF-59E4-4D8E-B574-4C25BD71EB56',
  },
  {
    name: 'CC- Soft Lock.',
    restrictionTypeId: '29E51E40-5188-4CC0-AF2B-4CAC618DDBAF',
    mappingCode: '29E51E40-5188-4CC0-AF2B-4CAC618DDBAF',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'Underage.',
    restrictionTypeId: '8109D4EE-1832-47E8-8BF0-5E1437E1149D',
    mappingCode: '8109D4EE-1832-47E8-8BF0-5E1437E1149D',
  },
  {
    name: 'Promotion Abuse.',
    restrictionTypeId: '059C2FBA-167F-40FC-99B1-6257999B39EF',
    mappingCode: '059C2FBA-167F-40FC-99B1-6257999B39EF',
  },
  {
    name: 'Opposite Betting.',
    restrictionTypeId: '87E93649-823D-4627-B062-6282FCCDCF9B',
    mappingCode: '87E93649-823D-4627-B062-6282FCCDCF9B',
  },
  {
    name: 'Responsible Gaming (Weekly Wager Limit).',
    restrictionTypeId: '2739BA75-2C37-4955-823C-6D7735F01ED7',
    mappingCode: '2739BA75-2C37-4955-823C-6D7735F01ED7',
  },
  {
    name: 'Player Advantage.',
    restrictionTypeId: 'EC39885C-37FE-46A8-946E-6DDD2A7EEC4E',
    mappingCode: 'EC39885C-37FE-46A8-946E-6DDD2A7EEC4E',
  },
  {
    name: '3rd Party Notification.',
    restrictionTypeId: '0F227E0F-1950-4E6F-B651-772E571DF3D5',
    mappingCode: '0F227E0F-1950-4E6F-B651-772E571DF3D5',
  },
  {
    name: 'Suspected Fraud.',
    restrictionTypeId: '821AEA6E-CF79-4A77-8E84-7D050C0E60A9',
    mappingCode: '821AEA6E-CF79-4A77-8E84-7D050C0E60A9',
  },
  {
    name: 'Temporary Suspension.',
    restrictionTypeId: 'F8923CF0-2D0D-49F5-B4A4-7D92577982E0',
    mappingCode: 'F8923CF0-2D0D-49F5-B4A4-7D92577982E0',
  },
  {
    name: 'I Want To Take A Break From Gambling (Self Exclusion).',
    restrictionTypeId: 'B05B6C3F-A6E1-4226-B345-8CDE72E31D99',
    mappingCode: 'B05B6C3F-A6E1-4226-B345-8CDE72E31D99',
  },
  {
    name: 'Subpoena.',
    restrictionTypeId: '5712C7ED-9E72-41DB-9B6D-9040FD9293DB',
    mappingCode: '5712C7ED-9E72-41DB-9B6D-9040FD9293DB',
  },
  {
    name: 'Cc-Pending Soft Lock.',
    restrictionTypeId: '5D36F6E6-D1CB-4E4F-B374-9F59F576EEED',
    mappingCode: '5D36F6E6-D1CB-4E4F-B374-9F59F576EEED',
  },
  {
    name: 'Account Has Been Deactivated.',
    restrictionTypeId: '3351D831-552E-4BC3-A78B-A4132EEF38F3',
    mappingCode: '3351D831-552E-4BC3-A78B-A4132EEF38F3',
  },
  {
    name: 'Account Is Under Review. Must Be Reviewed By Support Staff Prior To Lifting This Lock Entry.',
    restrictionTypeId: '00329545-97E4-4B94-AAAF-A445E1471981',
    mappingCode: '00329545-97E4-4B94-AAAF-A445E1471981',
  },
  {
    name: 'Test Player Account Lock.',
    restrictionTypeId: '03A8837A-0F5F-44F7-AFAC-A5B073CFBE48',
    mappingCode: '03A8837A-0F5F-44F7-AFAC-A5B073CFBE48',
  },
  {
    name: 'New Password Required.',
    restrictionTypeId: 'D4575091-D3BD-4503-A63D-A64AAC2597DA',
    mappingCode: 'D4575091-D3BD-4503-A63D-A64AAC2597DA',
  },
  {
    name: 'Duplicate Account.',
    restrictionTypeId: '5F38F734-5A21-4E3C-A9F0-AA6848199D66',
    mappingCode: '5F38F734-5A21-4E3C-A9F0-AA6848199D66',
  },
  {
    name: 'Chargebacks.',
    restrictionTypeId: '556D0C62-161C-4EF9-BB48-AC8FF3926FCD',
    mappingCode: '556D0C62-161C-4EF9-BB48-AC8FF3926FCD',
  },
  {
    name: 'Account Takeover.',
    restrictionTypeId: 'DF5F3851-3342-4263-A1CC-B1A0E7D26A06',
    mappingCode: 'DF5F3851-3342-4263-A1CC-B1A0E7D26A06',
  },
  {
    name: 'Responsible Gaming (Daily Wager Limit).',
    restrictionTypeId: '20D8A2C4-0F22-4EBF-8E26-B34282DE4EDF',
    mappingCode: '20D8A2C4-0F22-4EBF-8E26-B34282DE4EDF',
  },
  {
    name: 'Responsible Gaming (Monthly Wager Limit).',
    restrictionTypeId: 'F5EFCEDF-1D14-466E-931D-B3CB27C68F7B',
    mappingCode: 'F5EFCEDF-1D14-466E-931D-B3CB27C68F7B',
  },
  {
    name: 'Confirmed Fraud.',
    restrictionTypeId: 'A11804DC-9D59-470F-9C68-CFA21FF42BB2',
    mappingCode: 'A11804DC-9D59-470F-9C68-CFA21FF42BB2',
  },
  {
    name: 'Board Request.',
    restrictionTypeId: 'DBEF3095-0754-4BB4-BB2F-D5EEE2D372C6',
    mappingCode: 'DBEF3095-0754-4BB4-BB2F-D5EEE2D372C6',
  },
  {
    name: 'Self Exclusion.',
    restrictionTypeId: '810DBC24-6B7E-458F-9BA2-D6442C6A810C',
    mappingCode: '810DBC24-6B7E-458F-9BA2-D6442C6A810C',
  },
  {
    name: 'Commission Abuse.',
    restrictionTypeId: '157B6181-64E9-49FA-9A10-DED5960C7272',
    mappingCode: '157B6181-64E9-49FA-9A10-DED5960C7272',
  },
  {
    name: 'Suspected Game Glitching.',
    restrictionTypeId: '9E878285-1872-444F-8350-DF2AF9BA86BE',
    mappingCode: '9E878285-1872-444F-8350-DF2AF9BA86BE',
  },
  {
    name: 'Self-Harm.',
    restrictionTypeId: '9F0F74BA-B777-48F5-84C8-E772836D716C',
    mappingCode: '9F0F74BA-B777-48F5-84C8-E772836D716C',
  },
  {
    name: 'Non-Compliance.',
    restrictionTypeId: 'F4DF4E1E-07CE-415B-93BE-E99FB01BB17E',
    mappingCode: 'F4DF4E1E-07CE-415B-93BE-E99FB01BB17E',
  },
  {
    name: 'Otp Limit Cooldown.',
    restrictionTypeId: 'BB776F97-B8C9-4026-ABFC-F114E5DA7774',
    mappingCode: 'BB776F97-B8C9-4026-ABFC-F114E5DA7774',
  },
  {
    name: 'Login Reset Function Disable Cooldown.',
    restrictionTypeId: '231882BE-EDA2-4183-A3D9-F873088187BA',
    mappingCode: '231882BE-EDA2-4183-A3D9-F873088187BA',
  },
  {
    name: 'I Have A Gambling Problem (Self Exclusion) Customer.',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000395',
    mappingCode: '90E133AC-305E-43CF-BC99-3182EDEE43AF',
  },
  {
    name: 'I Have A Gambling Problem (Self Exclusion) Customer.',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000396',
    mappingCode: '90E133AC-305E-43CF-BC99-3182EDEE43AF',
  },
  {
    name: 'I Have A Gambling Problem (Self Exclusion) Customer.',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000397',
    mappingCode: '90E133AC-305E-43CF-BC99-3182EDEE43AF',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000398',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000399',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000400',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000401',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000402',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000403',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000404',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000405',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000406',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000407',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
  {
    name: 'I Have Financial Difficulties (Self Exclusion).',
    restrictionTypeId: '00000000-0000-0000-CAB1-FF0000000408',
    mappingCode: 'EC196D58-0275-47F4-A4AF-58DF282AB605',
  },
];

export const restrictionMap = () => {
  const mapping = new Map<string, TRestrictionMapping>();
  const mappingCodes = new Set<string>();

  restrictions.forEach((restriction) => {
    mappingCodes.add(restriction.mappingCode);
  });

  mappingCodes.forEach((mappingCode) => {
    mapping.set(
      mappingCode,
      restrictions.filter(
        (restriction) => restriction.mappingCode === mappingCode,
      ),
    );
  });

  return mapping;
};
